class Exception {
    constructor(message, name = "Error"){
        this.message = message;
        this.name = name;
    }
}
export { Exception };
